import { render, staticRenderFns } from "./DailyDealTimer.vue?vue&type=template&id=3d5ebfd1&scoped=true&"
import script from "./DailyDealTimer.vue?vue&type=script&lang=js&"
export * from "./DailyDealTimer.vue?vue&type=script&lang=js&"
import style0 from "./DailyDealTimer.vue?vue&type=style&index=0&id=3d5ebfd1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5ebfd1",
  null
  
)

export default component.exports